// src/layouts/LayoutWithHeader.jsx
import Header from "../component/Header/Header";
import { Outlet, useLocation } from "react-router-dom";
import ChatWidget from "../component/Assistant/ChatWidget";
import BackToTop from "../component/ui/BackToTop";

export default function LayoutWithHeader() {
  const location = useLocation();
  return (
    <>
      <Header />
      {/* key = pathname → rejoue le fondu à chaque changement de route */}
      <main key={location.pathname} className="app-main with-header page-fade">
        <Outlet />
      </main>
      <ChatWidget />
      <BackToTop />
    </>
  );
}
